export default {
  'cart-deleted': {
    type: 'info',
    message: 'Koszyk usunięty'
  },
  'email-verify-failed': {
    type: 'error',
    message: 'Weryfikacja adresu email zakończona niepowodzeniem.'
  },
  'email-verify-ok': {
    type: 'success',
    message: 'Adres email przeszedł pozytywnie weryfikację.'
  },
  'error-receive-cart-data': {
    type: 'error',
    message: 'Nie można pobrać danych do koszyka. Jeżeli problem będzie się powtarzał, ' +
      'prosimy o kontakt za pośrednictwem poczty elektronicznej lub telefonu.'
  },
  'in-touch-message-create-success': {
    type: 'success',
    message: 'Wiadomość została pomyślnie wysłana.'
  },
  'Invalid credentials given.': {
    type: 'error',
    message: 'Wprowadzone dane nie pozwalają na zalogowanie do serwisu. Sprawdź i popraw ' +
      'dane, skorzystaj z procedury resetowania hasła lub skontaktuj się telefoniecznie ' +
      'bądź za pośrednictwe poczty elektronicznej z obsługą serwisu.'
  },
  'Request is missing password parameter.': {
    type: 'error',
    message: 'Aby się zalogować, wymagane jest podanie hasła.'
  },
  'user-account-change-success': {
    type: 'success',
    message: 'Dane konta zostały pomyślnie zaktualizowane.'
  },
  'user-account-password-reset-done': {
    type: 'success',
    message: 'Hasło do konta zostało pomyślnie zmienione.'
  },
  'user-account-password-reset-request': {
    message: 'Na podany adres email została wysłana wiadomość z dalszymi instrukcjami.'
  },
  'user-address-change-success': {
    type: 'success',
    message: 'Adres został pomyślnie zaktualizowany.'
  }
}



// WEBPACK FOOTER //
// ./src/store/messages-map.js